export default {
  getNotification: state => state.notification,
  getNotifications: state => state.notifications,
  getPermanentNotifications: state => state.permanentNotifications
}
